module.exports = __webpack_public_path__ + "static/img/200070.c87e22b3.png";